import { useMyMediaContext } from "../context/MyMediaContext";

export const FileCountDisplay = () => {
  const { totalFilesCount, files, searchQuery } = useMyMediaContext();
  const isFiltered = searchQuery.trim().length > 0;
  const displayCount = isFiltered ? files.length : totalFilesCount;

  return (
    <div className="text-sm text-muted-foreground">
      {isFiltered  &&  (
        <>
          Showing <span>{displayCount}</span> of{" "}
          <span>{totalFilesCount}</span> files
        </>
      )}
    </div>
  );
};
